import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { fakerSV } from '@faker-js/faker';
import { PropertyInformation } from '../../../../features/orders/createOrder/v2/types';
// @ts-ignore
import goteborg from '../data/goteborg.json';
// @ts-ignore
import kungalv from '../data/kungalv.json';

type DebugAddress = {
    street: string;
    zip: string;
    city: string;
};

enum DebugObjectType {
    Apartment = 1,
    House = 2
}

const fillOptions: Array<{
    label: string;
    addresses: DebugAddress[];
    objectType: DebugObjectType;
}> = [
    {
        label: 'Göteborg, Apartment',
        addresses: goteborg.addresses,
        objectType: DebugObjectType.Apartment
    },
    { label: 'Göteborg, House', addresses: goteborg.addresses, objectType: DebugObjectType.House },
    {
        label: 'Kungälv, Apartment',
        addresses: kungalv.addresses,
        objectType: DebugObjectType.Apartment
    },
    { label: 'Kungälv, House', addresses: kungalv.addresses, objectType: DebugObjectType.House }
];

const textColor = 'hsl(292.5, 87%, 82%)';

function debugPropertyInformation(
    addresses: DebugAddress[],
    objectType: DebugObjectType
): PropertyInformation {
    const address = fakerSV.helpers.arrayElement(addresses);

    return {
        owner: {
            ownerFirstName: fakerSV.person.firstName(),
            ownerLastName: fakerSV.person.lastName(),
            ownerEmailAddress: fakerSV.internet.email({ provider: 'example.com' }),
            ownerPrimaryPhoneNumber: fakerSV.phone.number()
        },
        address: {
            addressLine1: address.street,
            addressPostalNumber: address.zip,
            addressCity: address.city,
            addressDistrict: '',
            objectType,
            addressPointLocation: null
        },
        notes: '',
        extraDeliveryRecipients: ''
    };
}

type CreateOrderDebugMenuProps = {
    onFill: (propertyInformation: PropertyInformation) => void;
};

export function CreateOrderDebugMenu({ onFill }: CreateOrderDebugMenuProps) {
    let [anchor, setAnchor] = React.useState<HTMLElement | null>(null);
    let isExpanded = anchor !== null;

    return (
        <>
            <Button
                size="small"
                aria-haspopup="menu"
                aria-expanded={isExpanded}
                endIcon={isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                onClick={(event) => setAnchor(isExpanded ? null : event.currentTarget)}
                sx={{
                    position: 'absolute',
                    top: '8px',
                    right: '8px',
                    zIndex: 1,
                    textTransform: 'none',
                    fontWeight: 'bold',
                    color: textColor,
                    backgroundColor: '#B10DC9',
                    '&:hover': { backgroundColor: '#8f0aa3' }
                }}
            >
                Debug menu
            </Button>
            <Menu anchorEl={anchor} open={isExpanded} onClose={() => setAnchor(null)}>
                {fillOptions.map((option) => (
                    <MenuItem
                        key={option.label}
                        onClick={() => {
                            setAnchor(null);
                            onFill(debugPropertyInformation(option.addresses, option.objectType));
                        }}
                    >
                        {`Fill form [${option.label}]`}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
